<template>
  <div style="width: 100%; padding: 20px" v-if="item != null">
    <b-row align-v="start" class="mb-3">
      <b-col cols="12">
        <b-row>
          <b-col cols="1">
            <div v-if="item.anhnhanvien == null">
              <i class="fas fa-user"></i>
            </div>
            <div v-else>
              <img :src="item.anhnhanvienpath" style="max-width: 100px;" />
            </div>
          </b-col>
          <!-- NEXT TO THE PICTURE -->
          <b-col cols="4">
            <!-- <b-row class="mb-3">
              <b-col cols="4">Mã nhân viên:</b-col>
              <b-col>
                <b>{{item.manhanvien}}</b>
              </b-col>
            </b-row> -->
            <b-row class="mb-3">
              <b-col cols="4">
                Name:
                <!-- Họ và tên: -->
              </b-col>
              <b-col>
                <b>{{ item.hovaten }}</b>
              </b-col>
            </b-row>
            <!-- <b-row class="mb-3">
              <b-col cols="4">Tên tiếng anh:</b-col>
              <b-col>
                <b>{{item.tentienganh}}</b>
              </b-col>
            </b-row> -->
            <b-row class="mb-3">
              <b-col cols="4">
                Date of birth:
                <!-- Ngày sinh: -->
              </b-col>
              <b-col>
                <b>{{ item.ngaysinh | moment("DD/MM/YYYY") }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                Phone Number:
                <!-- Điện thoại: -->
              </b-col>
              <b-col>
                <b>{{
                  item.employeeContact == null
                    ? ""
                    : item.employeeContact.dtdidong
                }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                Line Manager:
                <!-- Điện thoại: -->
              </b-col>
              <b-col>
                <b>{{ linemanager == null ? "" : linemanager.hovaten }}</b>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row class="mb-3">
              <b-col cols="4">
                ID Card:
                <!-- CMND: -->
              </b-col>
              <b-col>
                <b>{{ item.cmndso }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                <!-- Ngày cấp: -->
                Issued Date:
              </b-col>
              <b-col>
                <b>{{ item.cmndngaycap | moment("DD/MM/YYYY") }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                <!-- Nơi cấp: -->
                Issued Place:
              </b-col>
              <b-col>
                <b>{{ item.cmndnoicap }}</b>
              </b-col>
            </b-row>
          </b-col>
          <!-- END NEXT TO PICTURE -->
          <b-col cols="4">
            <b-row class="mb-3">
              <b-col cols="4">Email:</b-col>
              <b-col>
                <b>{{ item.email }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                PIT, SSI, Bank Info:
                <!-- Tài khoản: -->
              </b-col>
              <b-col>
                <b>{{ item.sotaikhoannganhang }}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                Bank:
                <!-- Ngân hàng: -->
              </b-col>
              <b-col>
                <b>{{ item.nganhang }}</b>
              </b-col>
            </b-row>
            <!-- <b-row class="mb-3">
              <b-col cols="4">Vị trí công việc:</b-col>
              <b-col>
                <b>{{item.employeeContract == null ? '' : findFirst(vitricongviecs, item.employeeContract.vitricongviec)}}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">Công ty:</b-col>
              <b-col>
                <b>{{item.employeeContract == null ? '' : findFirstDepartment(departments, item.employeeContract.donvicongtac)}}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">Ngày thử việc:</b-col>
              <b-col>
                <b>{{formatDate(item.ngaythuviec)}}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">Ngày chính thức:</b-col>
              <b-col>
                <b>{{formatDate(item.ngaychinhthuc)}}</b>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="3">
            <b-row class="mb-3">
              <b-col cols="4">CMND/CCCD/HC:</b-col>
              <b-col>
                <b>{{item.cmndso}}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">Ngày cấp:</b-col>
              <b-col>
                <b>{{formatDate(item.cmndngaycap)}}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">Nơi cấp:</b-col>
              <b-col>
                <b>{{item.cmndnoicap}}</b>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">Hết hạn:</b-col>
              <b-col>
                <b>{{formatDate(item.cmndngayhethan)}}</b>
              </b-col>
            </b-row> -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-v="start"> </b-row>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  name: "ThongTinChungView",
  props: ["departments", "vitricongviecs", "item", "linemanager"],
  data() {
    return {
      optionsGioiTinh: [
        { value: 1, text: "Nam" },
        { value: 2, text: "Nữ" },
      ],
      optionsDanToc: [],
      optionsTonGiao: [],
      optionsQuocTich: [],
    };
  },
  // watch: {
  //   "item": function (newValue, oldValue) {
  //     this.initData();
  //   },
  // },
  // created() {
  //   this.initData();
  // },
  methods: {
    // initData() {
    //   if (this.item != null) {
    //     axios
    //     .get(`/api/employee/${this.item.manhanvien}`)
    //     .then((response) => {
    //       this.item = response.data;
    //     })
    //     .catch((err) => {
    //       this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
    //     });
    //   }
    // },
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.tendonvi;
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
